import { toast } from "react-toastify";
import Parse from "../../api/ApiConfig";

export const getLeaseInfo = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getLeaseInfo`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getAfInfo = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getAfInfo`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getuserProfiles = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getProfiles`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const fetchAdminWallet = async (walletId) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getWalletDetails`, {
			method: "POST",
			body: JSON.stringify({ walletId }),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		const data = await response.json();

		return data;
	} catch (error) {
		if (error?.message === "Failed to fetch") {
			toast.error("You are not connected to the internet.");
		} else if (error?.message.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
		} else {
			toast.error(error);
		}
	}
};

export const generateAccountDetails = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getAccountDetails`, {
			method: "POST",
			body: JSON.stringify({}),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		const responseTwo = await fetch(`${Parse.serverURL}/functions/getPagaAccountDetails`, {
			method: "POST",
			body: JSON.stringify({}),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		const responseJson = await response.json();
		const responseTwoJson = await responseTwo.json();

		if (responseJson?.error || responseTwoJson?.error) {
			toast.error("Failed to generate account details");
			return;
		}

		return {
			providus: responseJson?.result,
			paga: responseTwoJson?.result?.pagaAccountDetails,
		};
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			toast.error("Oops, Service provider has been disconnected!");
		} else if (error?.message.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
		} else {
			toast.error("Failed to generate payment details. Try again!");
		}
	}
};

export const walletType = {
	main: "wallet",
	regularSavings: "regular-savings",
	assetBasedSavings: "asset-based-savings",
	leaseInvestment: "lease-investment",
	riskFreeInvestment: "risk-free-investment",
	financeInvestment: "finance-investment",
};

export const onInputAmount = (e) => {
	e.target.value = e.target.value.replace(/[^\dA-Z]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const deductPaymentFromUserWallet = async (paymentInfo, successContext) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/makeWalletWithdrawal`, {
			method: "POST",
			body: JSON.stringify(paymentInfo),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
			},
		});

		const responseData = await response.json();
		if (responseData?.error) {
			toast.error("Failed to deduct funds from wallet");
			return;
		}

		const data = responseData.result;

		return {
			wallet: data?.data?.accounts,
			message: successContext,
		};
	} catch (error) {
		console.log(error);
		toast.error("Failed to deduct payment");
	}
};

export const moveUserFunds = async (details) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/moveFunds`, {
			method: "POST",
			body: JSON.stringify(details),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		const responseData = await response.json();

		if (responseData?.error) {
			toast.error("Failed to move funds between wallets.");
			return;
		}
		const data = responseData.result;

		return {
			message: details?.message,
			wallet: data?.updatedWallet.accounts,
		};
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet");
		} else if (error?.message?.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
			window.location.href = "login";
		} else {
			toast.error("Failed to move funds");
		}
	}
};

export const fetchAllBanks = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getPagaBanks`, {
			method: "POST",
			body: JSON.stringify({}),
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});

		const responseData = await response.json();
		if (responseData?.error) {
			toast.error("Failed to fetch available banks");
			return;
		}
		const data = responseData?.result.banks;

		return data;
	} catch (error) {
		toast.error(error?.message);
	}
};

export const verifyBankAccount = async (bankInfo) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/fetchAccountDetailsPaga`, {
			method: "POST",
			body: JSON.stringify(bankInfo),
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const responseData = await response.json();
		const data = responseData?.result;

		return data;
	} catch (error) {
		toast.error(error?.message);
	}
};

export const getInitials = (name) => {
	const splitName = name?.split(" ").filter((a) => a !== "") || [];
	const firstLetter = splitName[0]?.slice(0, 1);
	const secondLetter = splitName[1]?.slice(0, 1);
	return name ? `${firstLetter}${secondLetter}` : "NA";
};

export const withdrawFundsFromWallet = async (withdrawalDetails) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/withdrawToBankPaga`, {
			method: "POST",
			body: JSON.stringify(withdrawalDetails),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const responseData = await response.json();
		const data = responseData?.result;

		return data;
	} catch (error) {
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet.");
		} else if (error?.message?.includes("because of insufficient balance")) {
			toast.error("We are unable to process withdrawals at this time.");
		} else {
			toast.error("Failed to process withdrawal. Try again.");
		}
	}
};

export const getProfileCompletion = (userData, minValue) => {
	if (!userData) {
		return 0;
	} else {
		const truthyValues = Object.values(userData).filter((a) => a).length;
		return Math.round(truthyValues * minValue);
	}
};

export const getOtp = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/resetPin`, {
			method: "POST",
			body: JSON.stringify({}),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const responseData = await response.json();
		const data = responseData;

		return data;
	} catch (error) {
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet.");
			return;
		}
		if (error?.message?.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
			setTimeout(() => {
				window.location.href = "/login";
			}, 1200);
			return;
		} else {
			toast.error("Failed to send OTP. Try again!");
		}
	}
};

export const verifyOtp = async (otp) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/verifyPinResetOtp`, {
			method: "POST",
			body: JSON.stringify({ otp }),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const responseData = await response.json();
		const data = responseData;

		return data;
	} catch (error) {
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet.");
			return;
		}
		if (error?.message?.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
			setTimeout(() => {
				window.location.href = "/login";
			}, 1200);
			return;
		} else if (error?.message?.includes("Invalid OTP")) {
			toast.error("The OTP provided is incorrect. Please check!");
		} else if (error?.message?.includes("OTP expired. Request for a new one!")) {
			toast.error("OTP has expired. Please request a new one");
		} else {
			toast.error("OTP verfication failed. Try again!");
		}
	}
};

export const updateUserAndPersonalData = async (personalData, userData) => {
	try {
		const personal = Parse.Object.extend("Personal");
		const query = new Parse.Query(personal);
		query.equalTo("userId", Parse.User.current()?.id);
		let myObject = null;

		try {
			myObject = await query.first();

			if (myObject) {
				// If the object exists, update its attributes with the values in newData
				for (const key in personalData) {
					myObject.set(key, personalData[key]);
				}
			} else {
				// If the object doesn't exist, create a new one
				const Personal = Parse.Object.extend("Personal");
				myObject = new Personal();

				myObject.set("userId", Parse.User.current()?.id);
				for (const key in personalData) {
					myObject.set(key, personalData[key]);
				}
			}

			// Save the object to Parse
			const createdOrUpdatedPersonalData = await myObject.save();

			const queryTwo = new Parse.Query(Parse.User);

			const object = await queryTwo.get(Parse.User.current()?.id);
			await object.save(userData);

			return createdOrUpdatedPersonalData;
		} catch (e) {
			toast.error("Failed to update details");
		}
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			toast.error("Oops, Service provider has been disconnected!");
		} else {
			toast.error("Failed to update details");
		}
	}
};

export const formatDOBFromBVN = (dob) => {
	const splitDob = dob?.split("-");
	const reverseDob = splitDob?.reverse();
	const formatedDob = reverseDob?.join("-");
	// console.log(dob, splitDob, reverseDob, formatedDob);
	return formatedDob;
};
